import { ReactNode } from 'react';
import styles from './PunchupDangerZone.module.css';

interface PunchupDangerZoneProps {
	title: string;
	description: string;
	/** Optional amber warning message shown below the description. */
	warning?: string;
	actions: ReactNode;
}

const PunchupDangerZone = ({ title, description, warning, actions }: PunchupDangerZoneProps) => (
	<div className={styles.dangerZone}>
		<h3 className={styles.dangerZoneTitle}>{title}</h3>
		<div className={styles.dangerZoneContent}>
			<div className={styles.dangerZoneText}>
				<span>{description}</span>
				{warning && <span className={styles.warningText}>{warning}</span>}
			</div>
			<div className={styles.dangerZoneButtons}>{actions}</div>
		</div>
	</div>
);

export { PunchupDangerZone };
